import React from 'react';
import ReactDOM from 'react-dom/client';

// Inter — design-system body font. We bundle the four weights actually used:
//   400 body, 500 medium (InfoField value), 600 semibold (titles/badges), 700 bold (rare).
// Importing through @fontsource gives us self-hosted woff2 with no Google Fonts
// network hop, which is faster on Cloudflare Pages cold starts.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
